class Authors {
    constructor() {
        this.init();
    }

    init() {
        const authorsPlaceholder = document.getElementsByClassName('authors-placeholder');
        const authorsList = document.getElementsByClassName('js-authors-list');
        if (authorsPlaceholder && authorsPlaceholder.length > 0 && authorsList && authorsList.length > 0) {
            this.showAuthors(authorsList[0]);
            authorsPlaceholder[0].innerHTML = authorsList[0].outerHTML;
            authorsPlaceholder[0].firstChild.classList.remove('js-authors-list');
            authorsList[0].parentNode.removeChild(authorsList[0]);
        }
        else if (authorsPlaceholder && authorsPlaceholder.length > 0) {
            authorsPlaceholder[0].parentNode.removeChild(authorsPlaceholder[0]);
        }
        else if (authorsList && authorsList.length > 0) {
            this.showAuthors(authorsList[0]);
        }
    }

    showAuthors(authors) {
        if (authors.getAttribute('style') != null && authors.getAttribute('style') != "") {
            authors.setAttribute('style', '');
        }
    }
}

export default Authors;